/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_EstateInputs */

const en_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estate`)
};

const es_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finca`)
};

const fr_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaine`)
};

const de_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwesen`)
};

const ja_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エステート`)
};

const zh_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`庄园`)
};

const ar_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عزبة`)
};

const id_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perkebunan`)
};

const it_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenuta`)
};

const ru_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поместье`)
};

const pt_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriedade`)
};

const ko_val_estate = /** @type {(inputs: Val_EstateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`단독 주택`)
};

/**
* | output |
* | --- |
* | "Estate" |
*
* @param {Val_EstateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_estate = /** @type {((inputs?: Val_EstateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_EstateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_estate(inputs)
	if (locale === "es") return es_val_estate(inputs)
	if (locale === "fr") return fr_val_estate(inputs)
	if (locale === "de") return de_val_estate(inputs)
	if (locale === "ja") return ja_val_estate(inputs)
	if (locale === "zh") return zh_val_estate(inputs)
	if (locale === "ar") return ar_val_estate(inputs)
	if (locale === "id") return id_val_estate(inputs)
	if (locale === "it") return it_val_estate(inputs)
	if (locale === "ru") return ru_val_estate(inputs)
	if (locale === "pt") return pt_val_estate(inputs)
	return ko_val_estate(inputs)
});